import { create } from "zustand";
import { Model } from "@/components/model-selector/types.ts";
import {
  localStorageGetObject,
  localStorageSetObject,
} from "@/utils/utils.ts";
import { Attachment, Image } from "@/models/images.ts";

const localStorageKey: string = "images.current_model";

// Zustand
type ImagesStore = {
  models: Model[] | null;
  currentModel: Model | null;
  aspectRatio: string | null;
  image: Image | null;
  attachments: Attachment[];
  message: string;
  placeholder: string;

  setMessage: (msg: string) => void;
  setPlaceholder: (text: string) => void;
  setModels: (models: Model[]) => void;
  setCurrentModel: (model: Model) => void;
  setAspectRatio: (ar: string | null) => void;
  setImage: (img: Image | null) => void;
  setAttachments: (attachments: Attachment[]) => void;
};

const initialModel = localStorageGetObject(localStorageKey)
  ? (localStorageGetObject(localStorageKey) as Model)
  : ({
      id: "minimax/image-01",
      name: "Minimax Image",
      description: "Бюджетная модель с хорошим качеством",
    } as Model);

export const useImagesStore = create<ImagesStore>()((set) => ({
  message: "",
  placeholder:
    "Опишите что необходимо изобразить.\nБолее детальное описание помогает нейросети лучше понять вашу идею 😉",
  models: null,
  currentModel: initialModel,
  aspectRatio: "1:1",
  image: null,
  attachments: [],
  selectorOpen: false,

  setMessage: (msg: string) =>
    set((state) => {
      return { message: msg };
    }),
  setPlaceholder: (text: string) =>
    set((state) => {
      return { placeholder: text };
    }),
  setModels: (models: Model[]) =>
    set((state) => ({
      models: models,
    })),
  setCurrentModel: (model: Model) => {
    set((state) => {
      if (state.models) {
        let found = state.models.find((item: Model) => item.id == model.id);
        if (found) {
          model = found;
        }
      }
      localStorageSetObject(localStorageKey, model);
      return { currentModel: model };
    });
  },
  setAspectRatio: (ar: string | null) =>
    set((state) => {
      return { aspectRatio: ar };
    }),
  setImage: (img: Image | null) =>
    set((state) => {
      return { image: img };
    }),
  setAttachments: (attachments: Attachment[]) =>
    set((state) => {
      return { attachments: attachments };
    }),
}));
